import { render, staticRenderFns } from "./version-record.vue?vue&type=template&id=15968d86&"
import script from "./version-record.vue?vue&type=script&lang=js&"
export * from "./version-record.vue?vue&type=script&lang=js&"
import style0 from "./version-record.vue?vue&type=style&index=0&id=15968d86&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports